<script setup lang="ts">
import { PhMoon, PhSun } from '@phosphor-icons/vue'
import { useAppStore } from '@/stores/app.store'
import { computed } from 'vue'

// stores
const { toggleTheme } = useAppStore()

// computed
const isDarkMode = computed(() => useAppStore().isDarkMode)
</script>

<template>
  <button
    @click="toggleTheme"
    class="relative flex w-10 h-10 p-2 rounded-full hover:bg-stone-100 dark:hover:bg-stone-700 transition-colors duration-150 overflow-hidden cursor-pointer"
  >
    <!-- Moon Icon -->
    <ph-moon
      v-show="isDarkMode"
      class="absolute m-auto text-yellow-200 inset-0 transition-all duration-150 ease-in-out"
      :class="isDarkMode ? 'opacity-100 scale-100 rotate-0' : 'opacity-0 scale-75 rotate-45'"
      weight="duotone"
      size="24"
    />

    <!-- Sun Icon -->
    <ph-sun
      v-show="!isDarkMode"
      class="absolute m-auto text-yellow-600 inset-0 transition-all duration-150 ease-in-out"
      :class="!isDarkMode ? 'opacity-100 scale-100 rotate-0' : 'opacity-0 scale-75 rotate-45'"
      weight="duotone"
      size="24"
    />
  </button>
</template>

<style scoped></style>
